<template>
  <BaseImage image-class="img_glow_left desktop_show" src="/static/images/lights_big.svg" alt="" fallbackSrc="/static/images/lights_big.svg" />
  <BaseImage image-class="img_glow_left mobile_show" src="/static/images/lights_small.svg" alt="" fallbackSrc="/static/images/lights_small.svg" />
</template>

<script setup>
import BaseImage from '@/components/image/BaseImage.vue';
</script>
